import styles from './buyer-select.module.sass';
import arrowDown from '@@/mixing/images/arrow-down.svg';
import { useEffect, useState } from 'react';
import classNames from 'classnames';

export const BuyerSelect = ({
  children,
  expanded: open,
  id,
  idx,
  setSelectedBuyerId,
  buyerData,
}: IBuyerSelect) => {
  useEffect(() => {
    if (open === true) setExpanded(true);
  }, [open]);
  const [expanded, setExpanded] = useState(false);
  return (
    <div className={styles.buyer__select}>
      <div className={styles.component__body}>
        <span
          onClick={() => {
            !expanded && setSelectedBuyerId(idx);
            setExpanded(!expanded);
          }}
        >
          <img
            src={arrowDown}
            className={classNames(expanded && styles.expandedArrow)}
            alt="arrow-down"
          />
          {buyerData?.company_name}
          <span style={buyerData?.type === 'internal' ? { color: '#409BFF' } : undefined} className={styles.buyer__type}>
            {buyerData?.type === 'internal'
              ? 'ваш контрагент'
              : 'внешний контрагент'}
          </span>
          {/* <span className={styles.buyer__distance}>268 км</span> */}
        </span>
      </div>
      <div
        className={classNames(styles.component__content, expanded && styles.expanded)}
      >
        {children}
      </div>
    </div>
  );
};

interface IBuyerSelect {
  idx: number;
  children: JSX.Element;
  expanded?: boolean;
  id: number;
  setSelectedBuyerId: (idx: number) => void;
  buyerData: {
    company_id: number;
    company_name: string;
    enabled: boolean;
    type: 'internal' | 'external' | string;
  };
}
